export default __webpack_public_path__ + "static/media/gesture-one-finger-tap-double.9d04a710.svg";